import React, { useState, useEffect } from 'react';
import { GetRequest } from 'components/common';
import QuoteBuilderForm from 'components/quote_builder/QuoteBuilderForm.jsx';

// The owner's material create/manage form, for the /mcc empty-state adder and the filter-island Manage button. A
// material is a UserUnitPrice (a priced row), NOT a UserUnitPriceAttribute (machines) -- so there is NO library
// picker; this renders the quote-builder's own material price form (QuoteBuilderForm), the SAME one the in-section
// "add a price" popup uses (components/quote_builder/form_fields/UserUnitPrice.jsx). QuoteBuilderForm -- not
// SettingsTabs -- so it is JUST the price form, without the settings-page tab pills (unit prices / material types /
// brands): here the owner only needs to add / manage the PRICE. Standalone (no section create-context, matching
// the settings page). The big material config is not seeded on the page (there are several materials and each
// config is large); it is fetched on demand by key here, the moment the form is actually shown.
//
// The form opens on the price LIST (QuoteBuilderForm defaults to its list view). systemItemsFirst leads that list
// with the "Sık kullanılanlar" (frequently-used) system materials, putting the owner's own list + "add new" button
// beneath -- the /mcc empty state's shape (the Manage popup passes it too, but it only takes effect once the own
// list is empty). afterSave lets the embedder react to a saved material (the empty-state re-solves the section so
// the priced listing appears).
// Seed a NEW material's "Malzeme bobin mi?" (bobbin_enabled) default to the section's current bobbin state, so a
// material added while Bobin is on is created as a bobbin row. Only the config's default_value is changed (which
// QuoteBuilderForm#initialValues reads for a new record); editing an existing row still shows its own saved value,
// which the edit fetch loads over the default. A no-op unless defaultBobbinEnabled is a boolean (undefined for a
// section with no bobbin question) and the key actually has a bobbin_enabled field (carton) -- otherwise the config
// is returned unchanged. A fresh object is returned rather than mutating the fetched config.
const withBobbinDefault = (config, defaultBobbinEnabled) => {
  if (typeof defaultBobbinEnabled !== 'boolean') { return config; }
  return {
    ...config,
    attributes: config.attributes.map((attribute) => (
      attribute.name === 'bobbin_enabled'
        ? { ...attribute, default_value: defaultBobbinEnabled }
        : attribute
    )),
  };
};

const MaterialForm = ({ materialKey, afterSave, systemItemsFirst, defaultBobbinEnabled }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    GetRequest({
      url: `/quote-builder/config/settings/user_unit_prices/${materialKey}`,
      callback: (data) => { setConfig(data); },
    });
  }, [materialKey]);

  if (!config) { return <div>{t('quote_builder.please_wait')}</div>; }

  return (
    <QuoteBuilderForm
      config={withBobbinDefault(config, defaultBobbinEnabled)}
      afterSave={afterSave}
      systemItemsFirst={systemItemsFirst}
    />
  );
};

export default MaterialForm;
